// extracted by mini-css-extract-plugin
export default {"page":"DisabledNotice_page__r-tui","card":"DisabledNotice_card__4GuIa","title":"DisabledNotice_title__1awTY","body":"DisabledNotice_body__2vqhY"};